export default __webpack_public_path__ + "a01e44e25fd6e63ae90fc0a6a7d1d493.ico";